import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';

//Components
import { Button, Input, Form, Select } from "@gpstrackit/react-controls";
import { Typography } from '@mui/material';
//Chars
import ChartPie from 'Modules/dashboard/views/.components/chart/.components/pie';

//Actions
import { sizeDashboardPanelCreateEditModal } from 'Redux/actions'

const backgroundColor = [
    '#66BB6A',
    '#03A9F4',
    '#1D2734',
    '#018F82',
    '#13B2A3',
    '#37AFCC',
    '#00C6FC',
    '#00ACFB',
    '#008CDD',
    '#0059A0',
    '#2F4F6C',
    '#6685A7',
    '#825C8D',
    '#812F6F',
    '#006014',
    '#007F25',
    '#40BE60',
    '#69C97D',
    '#A9EAB3',
    '#ECB651',
    '#EA6947',
    '#D13C3C',
    '#AC2A47',
    '#C23E68',
    '#E97694',
]

const CreateEditClipRequestByStatus = (props) => {
    const { onSubmit, handleClose } = props;
    const { messages } = useIntl();

    const dispatch = useDispatch();
    const editCreateDashboardGadgets = useRef();

    //Local States
    const [formData, setFormData] = useState({});
    const [dataChart, setDataChart] = useState({});

    const optionsFrecuency = [
        { id: 300, name: messages['dashboard_gadget_five_minutes'] },
        { id: 900, name: messages['dashboard_gadget_fifteen_minutes'] },
        { id: 1800, name: messages['dashboard_gadget_thirty_minutes'] },
        { id: 3600, name: messages['dashboard_gadget_one_hour'] },
        { id: 7200, name: messages['dashboard_gadget_two_hour'] }
    ];

    const optionsTimeMetric = [
        { id: `today`, name: messages['dashboard_gadget_today'] },
        { id: `yesterday`, name: messages['dashboard_gadget_yesterday'] },
        { id: `thisweek`, name: messages['dashboard_gadget_thisweek'] },
        { id: `lastweek`, name: messages['dashboard_gadget_lastweek']},
        { id: `thismonth`, name: messages['dashboard_gadget_this_month'] },
        { id: `lastmonth`, name: messages['dashboard_gadget_last_month'] },
        { id: `thisyear`, name: messages['dashboard_gadget_this_year'] },
        { id: `last7days`, name: messages['dashboard_gadget_last7days'] },
        { id: `last15days`, name: messages['dashboard_gadget_last15days'] },
        { id: `last30days`, name: messages['dashboard_gadget_last30days'] },
    ]

    const {
        loadingCreateEdit,
        gadGet
    } = useSelector((state) => state.dashboardPanelMainRedux);

    const validateData = () => {
        onSubmit({
            ...formData,
            dateTimeRange: formData.dateTimeRange.id,
            refreshSeconds: formData.refreshSeconds.id,
            type: 'ClipRequestByStatus',
        })
    }

    useEffect(() => {
        dispatch(sizeDashboardPanelCreateEditModal('medium'));
    }, [])

    const dataChartChange = (timeMetric) => {
        let labels = ["timeout", "requestDecline"]
        let data = [34, 50];
        switch (timeMetric) {
            case 'today':
                data = [787];
                labels = ["requestDecline"]
                break;
            case 'yesterday':
                data = [78, 456, 56];
                labels = ["requestDecline", "mp4RemuxFinished", "timeout"]
                break;
            case 'thismonth':
                data = [23, 787];
                labels = ["timeout", "requestDecline"]
                break;
            case 'lastquarter':
                data = [56, 678];
                labels = ["timeout", "requestPending"]
                break;
            case 'quarter':
                data = [34, 234];
                labels = ["timeout", "requestPending"]
                break;
            case 'thisyear':
                data = [89, 345];
                labels = ["timeout", "requestPending"]
                break;
            case 'last7days':
                data = [62, 345];
                labels = ["timeout", "requestPending"]
                break;
            case 'last15days':
                data = [89, 456, 56];
                labels = ["timeout", "requestPending", "RequestDecline"]
                break;
            case 'last30days':
                data = [13, 897, 156];
                labels = ["timeout", "requestPending", "mp4RemuxFinished"]
                break;
        }

        setDataChart({
            labels: labels,
            unit: "Total",
            datasets: [{
                label: 'Total',
                data: data,
                backgroundColor: backgroundColor,
                hoverOffset: 4
            }]
        })
    }

    useEffect(() => {
        if (gadGet?.hasOwnProperty('name')) {
            let settings = JSON.parse(gadGet.settings);
            setFormData({
                ...formData,
                name: gadGet.name,
                dateTimeRange: optionsTimeMetric.filter(time => time?.id === settings?.dateTimeRange),
                refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0],
            })
            dataChartChange(formData?.timeMetric?.id);
        } else {
            setFormData({ ...formData, chartType: 'pie' });
            dataChartChange(optionsTimeMetric[0].id)
        }
    }, [open, gadGet])

    return (
        <div className="create-edit-container">
            <div className="create-edit-preview" >
                <div className="create-edit-preview-chart" >
                    <Typography className="create-edit-preview-label" variant="subtitle1">
                        {messages['dashboard_gadget_preview']}
                    </Typography>
                    <ChartPie data={dataChart} />
                </div>
            </div>
            <div className="create-edit-separator" >
                <Form
                    ref={editCreateDashboardGadgets}
                    onSubmit={() => {
                        return true
                    }}
                    onValidSubmit={validateData}
                    style={{ height: '100%' }}>
                    <div>
                        <div>
                            <Input
                                id="name"
                                value={formData.name || ""}
                                onChange={(value) => setFormData({ ...formData, name: value })}
                                minLength={1}
                                maxLength={40}
                                label={messages['dashboard_gadget_title']}
                                placeholder={messages['dashboard_gadget_title']}
                                type="text"
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div className="create-edit-form-item">
                            <Select
                                id="refreshSeconds"
                                label={messages['dashboard_gadget_frequency_refresh']}
                                placeholder={messages['dashboard_gadget_frequency_refresh']}
                                options={optionsFrecuency}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.refreshSeconds}
                                onChange={(value) => setFormData({ ...formData, refreshSeconds: value })}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div className="create-edit-form-item" style={{ marginBottom: 190 }}>
                            <Select
                                id="timeMetric"
                                label={messages['dashboard_gadget_time_metric']}
                                placeholder={messages['dashboard_gadget_time_metric']}
                                options={optionsTimeMetric}
                                textField="name"
                                valueField="id"
                                isSearchable={false}
                                value={formData.dateTimeRange}
                                onChange={(value) => {
                                    setFormData({ ...formData, dateTimeRange: value });
                                    dataChartChange(value.id);
                                }}
                                isClearable
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                    </div>
                </Form>
                <div className="create-edit-buttons" style={{ width: '100%', backgroundColor: '#fff' }}>
                    <Button
                        disabled={loadingCreateEdit}
                        className="btn-cancel"
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            dispatch(sizeDashboardPanelCreateEditModal('small'));
                            handleClose();
                        }}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        disabled={loadingCreateEdit}
                        onClick={(e) => editCreateDashboardGadgets.current.submit()}
                        className="btn-dark-blue"
                    >
                        {messages['save']}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CreateEditClipRequestByStatus